function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { GroupsApiService } from "./Services/GroupsApiService";
import { CommonBuilder } from "./Helpers/CommonBuilder";
import { FormManager } from "./Helpers/FormManager";
import { InnerPageBuilder } from "./Helpers/InnerPageBuilder";
import { ModalBuilder } from "./Helpers/ModalBuilder";
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { HouseholdApiService } from "./Services/HouseholdApiService";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { DateTimeFormatter } from "./Helpers/DateTimeFormatter";
import { ErrorBuilder } from "./Helpers/ErrorBuilder";
import { ReturnContext } from "./Shared/ReturnContextProvider";
import { LookupApiService } from "./Services/LookupApiService";
import { CommunicationService } from "./Services/CommunicationService";
import { Configuration } from "./Shared/Configuration";
export var MppGroupDetails = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppGroupDetails, _ComponentBase);

  var _super = _createSuper(MppGroupDetails);

  function MppGroupDetails() {
    var _this;

    _classCallCheck(this, MppGroupDetails);

    _this = _super.call(this);
    _this._ActiveTab = '';
    _this._IsFull = false;
    return _this;
  }

  _createClass(MppGroupDetails, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));

      if (!!this._$detailsContainer) {
        this.loadAttributes();
        this.LoadGroup(this._i18n, false);
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.countGroupInquiries = this.hasAttribute("countgroupinquiries") && this.getAttribute("countgroupinquiries") === "true";
      this.inquireFullGroups = this.hasAttribute("inquirefullgroups") && this.getAttribute("inquirefullgroups") === "true";
      this.inquiryEmailTemplate = this.getAttribute("inquiryemailtemplate") || "";
      this.returnUrl = this.getAttribute("returnurl");
      this.showFullAddress = this.hasAttribute("showfulladdress") && this.getAttribute("showfulladdress") === "true";
      this.signupEmailTemplate = this.getAttribute("signupemailtemplate") || "";
      this.hideContactTab = this.hasAttribute("hidecontacttab") && this.getAttribute("hidecontacttab") === "true";
      this.hideSignUpTab = this.hasAttribute("hidesignuptab") && this.getAttribute("hidesignuptab") === "true";
      this.leaderSignupEmailTemplate = this.getAttribute("leadersignupemailtemplate") || "";
    } // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MppGroupDetails.WidgetDetails.tag);
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _mppWidgetsConfigValu;

        var i18n, mppWidgetsConfigValues;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                }

                return _context.abrupt("return");

              case 10:
                this._i18n = i18n; //attributes

                this.loadAttributes();
                _context.next = 14;
                return new Configuration().GetGlobalConfigurationSettingValues();

              case 14:
                mppWidgetsConfigValues = _context.sent;
                this._groupDetailWidgetIdParameterName = (_mppWidgetsConfigValu = mppWidgetsConfigValues.groupDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu !== void 0 ? _mppWidgetsConfigValu : "id";
                this._inquireActive = this._ActiveTab === 'inquire' ? "active" : "";
                this._signupActive = this._ActiveTab === 'signup' ? "active" : "";
                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div id="emptyContainer"><i class="mppw-spinner"></i></div><div id="detailsContainer"></div><div class="mpp-innerpage--map-container"><div id="map" class="mpp-innerpage--map"></div><div id="mapAddress" class="mpp-innerpage--map-info"></div></div><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div><div class="mpp-form--container" id="formContainer" style="display: none"><div class="mpp-form--tabs" id="formTabs"><label class="mpp-form--tab active" id="inquireTab"><input type="radio" name="formSelector" value="inquire"/>${i18n.inquiryOptionLabel}</label> <label class="mpp-form--tab" id="signUpTab"><input type="radio" name="formSelector" value="signup"/>${i18n.signUpOptionLabel}</label></div><div class="mpp-form--tabs-container"><div id="inquiryContainer" class="mpp-form--tab-content inquireTab active"><div id="userHasInquiredContainer"></div><div id="invalidInquiryEmailContainer"></div>${this.BuildInquiryForm(i18n)}</div><div id="signupContainer" class="mpp-form--tab-content signUpTab"><div id="userHasSignedUpContainer"></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div id="signupFormContainer"><div id="invalidSignUpEmailContainer"></div>${this.BuildSignUpForm(i18n)}</div></div></div></div></div>` ;
                this.BindHtmlElements(); // Load logged in user and household

                _context.next = 22;
                return this.GetCurrentUser(i18n);

              case 22:
                //Load group details
                this.LoadGroup(i18n, false); // Bind event listeners

                this.BindEventListeners(i18n);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "_getGroupId",
    value: function _getGroupId() {
      var groupId = CommonBuilder.GetId(this._groupDetailWidgetIdParameterName);

      if (!groupId) {
        groupId = CommonBuilder.GetId("id");
      }

      return groupId;
    }
  }, {
    key: "LoadGroup",
    value: function LoadGroup(i18n, forSignup) {
      var lookupService = new LookupApiService();

      var id = this._getGroupId(); // Check for valid email templates


      if (!!this.inquiryEmailTemplate) {
        this._getEmailTempate(this.inquiryEmailTemplate);
      }

      if (!!this.signupEmailTemplate) {
        this._getEmailTempate(this.signupEmailTemplate);
      }

      this._getGroupDetails(id, i18n, forSignup);
    } // istanbul ignore next

  }, {
    key: "getCommunicationService",
    value: function getCommunicationService() {
      return new CommunicationService();
    }
  }, {
    key: "_getEmailTempate",
    value: function _getEmailTempate(template) {
      var _this2 = this;

      var communicationService = this.getCommunicationService();
      communicationService.GetEmailTemplate(template).then(function (data) {
        if (data) {// Valid email template
        } else {
          if (!!_this2.inquiryEmailTemplate) {
            // Display invalid email template message
            _this2._$invalidInquiryEmailContainer.innerHTML +=  `<div id="invalidEmailTemplate" class="mppw-alert mppw-alert__danger"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">Invalid Email Template. Saving the record is allowed, however no email notifications will be sent.</span></div>` ;
          }

          if (!!_this2.signupEmailTemplate) {
            // Display invalid email template message
            _this2._$invalidSignUpEmailContainer.innerHTML +=  `<div id="invalidEmailTemplate" class="mppw-alert mppw-alert__danger"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">Invalid Email Template. Saving the record is allowed, however no email notifications will be sent.</span></div>` ;
          }
        }
      })["catch"](function (error) {});
    } // istanbul ignore next

  }, {
    key: "getGroupsApiService",
    value: function getGroupsApiService() {
      return new GroupsApiService();
    }
  }, {
    key: "_getGroupDetails",
    value: function _getGroupDetails(id, i18n, forSignup) {
      var _this3 = this;

      var groupsService = this.getGroupsApiService();
      groupsService.GetGroupDetails(id, this.showFullAddress, this.countGroupInquiries).then(function (data) {
        _this3._groupLeaders = data.contacts;
        _this3._$emptyContainer.innerHTML = "";
        _this3._$detailsContainer.innerHTML = "";
        var dateTimeFormatter = new DateTimeFormatter();
        var imageUrl = data.imageUrl,
            title = data.title,
            attributes = data.attributes,
            meetingDay = data.meetingDay,
            meetingFrequency = data.meetingFrequency,
            meetingTime = data.meetingTime,
            description = data.description,
            startDate = data.startDate,
            address = data.address,
            latitude = data.latitude,
            longitude = data.longitude,
            location = data.location,
            contacts = data.contacts,
            isFull = data.isFull,
            totalParticipantsCount = data.totalParticipantsCount,
            targetSize = data.targetSize;
        var capacityTitle = _this3._i18n.titleCapacityLabel,
            capacityLabel = '';

        if (isFull || targetSize !== null && Number(totalParticipantsCount) === Number(targetSize)) {
          capacityLabel = _this3._i18n.fullCapacityLabel;
        } else if (targetSize !== null && Number(totalParticipantsCount) < Number(targetSize)) {
          capacityLabel = totalParticipantsCount + ' ' + _this3._i18n.ofCapacityLabel + ' ' + targetSize;
        }

        var meetingDayText = meetingDay === 'Ongoing' ? _this3._i18n.ongoingLabel : meetingDay;
        _this3._groupData = data;

        for (var i = 0; i < contacts.length; i++) {
          if (contacts[i].nickName !== null && contacts[i].nickName !== '' && contacts[i].lastName !== null && contacts[i].lastName !== '') {
            contacts[i].displayName = contacts[i].nickName + ' ' + contacts[i].lastName;
          } else if (contacts[i].firstName !== null && contacts[i].firstName !== '' && contacts[i].lastName !== null && contacts[i].lastName !== '') {
            contacts[i].displayName = contacts[i].firstName + ' ' + contacts[i].lastName;
          }
        } // for


        var capacityLabelInfo = null;

        if (capacityLabel !== '') {
          capacityLabelInfo = InnerPageBuilder.BuildCapacityText(capacityTitle, capacityLabel);
        }

        var detailsContainerHTML = '';
        detailsContainerHTML += InnerPageBuilder.BuildInnerPageDetails(InnerPageBuilder.BuildGoBack(_this3._i18n.backToResultsHeader, _this3.returnUrl, ReturnContext.Categories.Groups), InnerPageBuilder.BuildFinderDetailImage(imageUrl, 'group'), InnerPageBuilder.BuildTitle(title), InnerPageBuilder.BuildLabels(attributes, i18n), InnerPageBuilder.BuildGroupDateTime(meetingFrequency, meetingDayText, meetingTime), InnerPageBuilder.BuildDescription(description), capacityLabelInfo, InnerPageBuilder.BuildSpecialText(_this3._i18n.startsLabel, dateTimeFormatter.IsInThePast(startDate) ? _this3._i18n.alreadyMeetingLabel : dateTimeFormatter.ToShortDate(startDate)), InnerPageBuilder.BuildContacts(contacts, _this3._i18n.groupLeadersLabel));

        if (location != null) {
          detailsContainerHTML += InnerPageBuilder.BuildSpecialText(_this3._i18n.locationLabel, location);
        }

        _this3._$detailsContainer.innerHTML += detailsContainerHTML;

        if (!!latitude && !!longitude && !!address) {
          _this3._$map.innerHTML = InnerPageBuilder.BuildGoogleMap(_this3._$map, latitude, longitude, address, title);
          _this3._$mapAddress.innerHTML = InnerPageBuilder.BuildMapAddress(address);
        } //Add User Warning Messaging


        var userHasInquired = data.userHasInquired,
            userHasSignedUp = data.userHasSignedUp;

        if (userHasInquired) {
          _this3._$userHasInquiredContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.userHasInquiredMessage, "</span>\n\t\t\t\t\t</div>");
        }

        if (userHasSignedUp) {
          _this3._$userHasSignedUpContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.userHasSignedUpMessage, "</span>\n\t\t\t\t\t</div>");
        }

        _this3._$formContainer.style.display = "";

        if (!!isFull) {
          _this3._$formContainer.style.display = "none";

          if (!!_this3.inquireFullGroups) {
            _this3._$formContainer.style.display = "block";
            _this3._$inquireTab.style.display = "block";
            _this3._$signupTab.style.display = "none";
          } else if (!!_this3.inquireFullGroups) {
            _this3._$formContainer.style.display = "none";
            _this3._$signupTab.style.display = "none";
            _this3._$inquireTab.style.display = "none";
          }
        }

        _this3.SetActiveTab(sessionStorage.groupDetailsMode); // Show/hide tabs


        _this3._IsFull = isFull;

        _this3.ShowHideTabs(_this3._IsFull);

        if (forSignup) {
          if (!!_this3.hideSignUpTab || _this3._IsFull) {
            _this3.HideSignUpBlankForm();

            _this3.SetMessage("success", i18n.signupThankYouMessageFull);

            _this3.ShowInquiryBlankForm();

            if (_this3._$contactGroupButton != null) {
              _this3._$contactGroupButton.disabled = false;
              _this3._$contactGroupButton.value = i18n.submitButtonText;
            }
          } else {
            _this3.ShowSignUpBlankForm();

            _this3.SetMessage("success", i18n.signupThankYouMessage);

            if (_this3._$signUpButton != null) {
              _this3._$signUpButton.disabled = false;
              _this3._$signUpButton.value = i18n.signUpButtonText;
            }
          }
        }
      }, function (error) {
        _this3._$detailsContainer.innerHTML += InnerPageBuilder.BuildInnerPageDetails(InnerPageBuilder.BuildGoBack(_this3._i18n.backToResultsHeader, _this3.returnUrl, ReturnContext.Categories.Groups));
        ErrorBuilder.Render(_this3._$emptyContainer, error, i18n);
      })["catch"](function (error) {
        _this3._$detailsContainer.innerHTML += InnerPageBuilder.BuildInnerPageDetails(InnerPageBuilder.BuildGoBack(_this3._i18n.backToResultsHeader, _this3.returnUrl, ReturnContext.Categories.Groups));
        ErrorBuilder.Render(_this3._$emptyContainer, error, i18n);
      });
    }
  }, {
    key: "ShowHideTabs",
    value: function ShowHideTabs(isFull) {
      // Hide tabs based on attribute values
      var tabsToHide = new Array();

      if (!!this.hideContactTab) {
        tabsToHide.push("inquireTab");
      }

      if (!!this.hideSignUpTab || isFull) {
        tabsToHide.push("signUpTab");
      }

      InnerPageBuilder.HideTabs(this._$formTabs, tabsToHide, this._root);
    } //Wire-up Events

    /*
     Wireup change event on radio button to route to new URL
     This is necessary in case user insn't logged in and needs to bounce off OAuth
     The returnUrl will bring them back to the signup form
    */

  }, {
    key: "BindEventListeners",
    value: function BindEventListeners(i18n) {
      var _this4 = this;

      var groupsService = this.getGroupsApiService();

      var groupId = this._getGroupId(); // Build tabs event handlers


      InnerPageBuilder.BindTabEventListeners(this._$formTabs, this._root);

      this._$loginButton.addEventListener("click", function () {
        OAuthService.SignIn();
      });

      this._$signUpAs.addEventListener("change", function (e) {
        groupsService.HasSignedUp(groupId, e.target.value).then(function (signedUpResponse) {
          if (signedUpResponse) {
            _this4._$userHasSignedUpContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.userHasSignedUpMessage, "</span>\n\t\t\t\t\t</div>");
          } else {
            _this4._$userHasSignedUpContainer.innerHTML = '';
          }
        })["catch"](function (error) {
          console.error(error);
          _this4._$userHasSignedUpContainer.innerHTML = '';

          _this4.SetMessage("danger", i18n.inquiryFailedMessage + " \n" + error);
        }); //Only show blank form if drop down value is null

        if (!!_this4._$signUpAs.value) {
          _this4.HideSignUpBlankForm();
        } else {
          _this4.ShowSignUpBlankForm();
        }
      });

      this._$signupTab.addEventListener("click", function (e) {
        //Only show blank form if drop down value is null
        if (!!_this4._$signUpAs.value) {
          _this4.HideSignUpBlankForm();
        } else {
          _this4.ShowSignUpBlankForm();
        }

        _this4._$resultMessageText.innerHTML = "";
        _this4._$resultMessageContainer.style.display = "none";
      });

      this._$inquireAs.addEventListener("change", function (e) {
        groupsService.HasInquired(groupId, e.target.value).then(function (inquiryResponse) {
          if (inquiryResponse) {
            _this4._$userHasInquiredContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.userHasInquiredMessage, "</span>\n\t\t\t\t\t</div>");
          } else {
            _this4._$userHasInquiredContainer.innerHTML = '';
          }
        })["catch"](function (error) {
          console.error(error);
          _this4._$userHasInquiredContainer.innerHTML = '';

          _this4.SetMessage("danger", i18n.inquiryFailedMessage + " \n" + error);
        }); //Only show blank form if drop down value is null

        if (!!_this4._$inquireAs.value) {
          _this4.HideInquiryBlankForm();
        } else {
          _this4.ShowInquiryBlankForm();
        }
      });

      this._$inquireTab.addEventListener("click", function (e) {
        //Only show blank form if drop down value is null
        if (!!_this4._$inquireAs.value) {
          _this4.HideInquiryBlankForm();
        } else {
          _this4.ShowInquiryBlankForm();
        }

        _this4._$resultMessageText.innerHTML = "";
        _this4._$resultMessageContainer.style.display = "none";
      });

      var inquiryForm = new FormManager(this._$inquiryForm);
      var signupForm = new FormManager(this._$signupForm);

      this._$inquiryForm.addEventListener("submit", function (event) {
        event.preventDefault();

        if (inquiryForm.IsValid()) {
          var formData = new FormData(_this4._$inquiryForm);

          if (!formData.get("ContactId")) {
            formData.set("ContactId", 0);
          }

          if (_this4._$contactGroupButton != null) {
            _this4._$contactGroupButton.disabled = true;
            _this4._$contactGroupButton.value = i18n.inquiringButtonText;
          }

          formData.append("TargetId", groupId);
          groupsService.Inquire(formData).then( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(inquiryResponse) {
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return inquiryForm.Reset();

                    case 2:
                      _context2.next = 4;
                      return signupForm.Reset();

                    case 4:
                      _this4._$userHasInquiredContainer.innerHTML = '';

                      _this4.ShowInquiryBlankForm();

                      _this4.SetMessage("success", i18n.inquirySuccessMessage);

                      if (_this4._$contactGroupButton != null) {
                        _this4._$contactGroupButton.disabled = false;
                        _this4._$contactGroupButton.value = i18n.submitButtonText;
                      }

                    case 8:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }())["catch"](function (error) {
            console.error(error);

            _this4.SetMessage("danger", i18n.inquiryFailedMessage + " \n" + error.Details);

            if (_this4._$contactGroupButton != null) {
              _this4._$contactGroupButton.disabled = false;
              _this4._$contactGroupButton.value = i18n.submitButtonText;
            }
          });
        } else {
          _this4.SetMessage("warning", i18n.validationFailedMessage);
        }
      });

      this._$signupForm.addEventListener("submit", function (event) {
        event.preventDefault();

        if (signupForm.IsValid()) {
          var formData = new FormData(_this4._$signupForm);

          if (!formData.get("ContactId")) {
            formData.set("ContactId", 0);
          }

          var _groupId = _this4._getGroupId();

          formData.append("TargetId", _groupId); // Add group leader contact ids to be emailed

          for (var i = 0; i < _this4._groupLeaders.length; i++) {
            formData.append("GroupLeaders", _this4._groupLeaders[i].contactId);
          }

          if (_this4._$signUpButton != null) {
            _this4._$signUpButton.disabled = true;
            _this4._$signUpButton.value = i18n.signingupButtonText;
          }

          groupsService.SignUp(formData).then( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(signUpResponse) {
              return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return signupForm.Reset();

                    case 2:
                      _context3.next = 4;
                      return inquiryForm.Reset();

                    case 4:
                      _this4._$userHasSignedUpContainer.innerHTML = '';
                      _context3.next = 7;
                      return _this4.LoadGroup(_this4._i18n, true);

                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }())["catch"](function (error) {
            console.error(error);
            var errorMessage = "Please make sure the email template used is valid and exists.";

            _this4.SetMessage("danger", i18n.signupFailedMessage + " " + errorMessage);

            if (_this4._$signUpButton != null) {
              _this4._$signUpButton.disabled = false;
              _this4._$signUpButton.value = i18n.signUpButtonText;
            }
          });
        } else {
          _this4.SetMessage("warning", i18n.validationFailedMessage);
        }
      });
    }
  }, {
    key: "GetCurrentUser",
    value: function () {
      var _GetCurrentUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(i18n) {
        var _this5 = this;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", UserService.GetCurrentUser().then(function (userInfo) {
                  _this5._$loginButtonContainer.style.display = "none";
                  _this5._$signupFormContainer.style.display = "";
                  _this5._$inquireAsContainer.style.display = "";
                  _this5._userInfo = userInfo;

                  _this5._getHouseholdMembers(userInfo);
                }, function () {
                  _this5._$signupFormContainer.style.display = "none";
                  _this5._$inquireAsContainer.style.display = "none";
                  _this5._$loginButtonContainer.style.display = "";

                  _this5.ShowInquiryBlankForm();

                  _this5.ShowSignUpBlankForm();
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetCurrentUser(_x3) {
        return _GetCurrentUser.apply(this, arguments);
      }

      return GetCurrentUser;
    }() // istanbul ignore next

  }, {
    key: "getHouseholdApiService",
    value: function getHouseholdApiService() {
      return new HouseholdApiService();
    }
  }, {
    key: "_getHouseholdMembers",
    value: function _getHouseholdMembers(userInfo) {
      var _this6 = this;

      var householdService = this.getHouseholdApiService();
      householdService.GetHouseholdMembers().then(function (members) {
        if (!!members && members.length > 0) {
          var allMembers = members.map(function (member) {
            return {
              id: member.contactId,
              value: member.displayName
            };
          }); // Use family data to populate dropdowns

          DropdownBuilder.LoadDropdown(_this6._$inquireAs, allMembers, "Blank Form");
          _this6._$inquireAs.value = userInfo.contactId;

          _this6.HideInquiryBlankForm();

          DropdownBuilder.LoadDropdown(_this6._$signUpAs, allMembers, "Blank Form");
          _this6._$signUpAs.value = userInfo.contactId;

          _this6.HideSignUpBlankForm();
        } else {
          // Family member data is null so just use contactInfo to populate dropdown
          // Use logged in users contact info to populate dropdowns
          var contactDropdown = [{
            id: userInfo.contactId,
            value: userInfo.user.displayName
          }];
          DropdownBuilder.LoadDropdown(_this6._$inquireAs, contactDropdown, "Blank Form");
          _this6._$inquireAs.value = userInfo.contactId;

          _this6.HideInquiryBlankForm();

          DropdownBuilder.LoadDropdown(_this6._$signUpAs, contactDropdown, "Blank Form");
          _this6._$signUpAs.value = userInfo.contactId;

          _this6.HideSignUpBlankForm();
        }
      });
    } // istanbul ignore next

  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      this._$detailsContainer = this._root.querySelector("#detailsContainer");
      this._$inquiryContainer = this._root.querySelector("#inquiryContainer");
      this._$signupContainer = this._root.querySelector("#signupContainer");
      this._$emptyContainer = this._root.querySelector("#emptyContainer");
      this._$invalidInquiryEmailContainer = this._root.querySelector("#invalidInquiryEmailContainer");
      this._$invalidSignUpEmailContainer = this._root.querySelector("#invalidSignUpEmailContainer");
      this._$formSelectors = this._root.querySelectorAll("input[name=formSelector]");
      this._$formContainer = this._root.querySelector("#formContainer");
      this._$inquiryForm = this._root.querySelector("#inquiryForm");
      this._$signupForm = this._root.querySelector("#signupForm");
      this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
      this._$signupFormContainer = this._root.querySelector("#signupFormContainer");
      this._$signupTab = this._root.querySelector('#signUpTab');
      this._$inquireTab = this._root.querySelector('#inquireTab');
      this._$loginButton = this._root.querySelector("#loginButton");
      this._$inquireAs = this._root.querySelector("#inquireAs");
      this._$inquireAsContainer = this._root.querySelector("#inquireAsContainer");
      this._$inquiryBlankForm = this._root.querySelector("#inquiryBlankForm");
      this._$inquirefirstNameText = this._root.querySelector("#inquire_firstNameText");
      this._$inquirelastNameText = this._root.querySelector("#inquire_lastNameText");
      this._$inquireemailText = this._root.querySelector("#inquire_emailText");
      this._$inquirephoneText = this._root.querySelector("#inquire_phoneText");
      this._$signUpAs = this._root.querySelector("#signUpAs");
      this._$signupBlankForm = this._root.querySelector("#signupBlankForm");
      this._$signUpfirstNameText = this._root.querySelector("#signUp_firstNameText");
      this._$signUplastNameText = this._root.querySelector("#signUp_lastNameText");
      this._$signUpemailText = this._root.querySelector("#signUp_emailText");
      this._$signUpphoneText = this._root.querySelector("#signUp_phoneText");
      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText");
      this._$formTabs = this._root.querySelectorAll(".mpp-form--tabs > label");
      this._$map = this._root.querySelector("#map");
      this._$mapAddress = this._root.querySelector("#mapAddress");
      this._$userHasInquiredContainer = this._root.querySelector("#userHasInquiredContainer");
      this._$userHasSignedUpContainer = this._root.querySelector("#userHasSignedUpContainer");
      this._$contactGroupButton = this._root.querySelector("#contactGroupButton");
      this._$signUpButton = this._root.querySelector("#signUpButton");
    }
  }, {
    key: "SetActiveTab",
    value: function SetActiveTab(selectedElementValue) {
      var urlParams = new URLSearchParams(location.search);

      if (!!this.hideContactTab) {
        selectedElementValue = "signup";
      } else if (!!this.hideSignUpTab) {
        selectedElementValue = "inquire";
      }

      sessionStorage.removeItem("groupDetailsMode");

      if (selectedElementValue === "signup" || urlParams.get("mode") === "signup" || sessionStorage.groupDetailsMode === "signup") {
        this._ActiveTab = 'signup';
        InnerPageBuilder.SetActiveTab(this._$formTabs, "signUpTab", this._root);
      } else {
        this._ActiveTab = 'inquire';
        InnerPageBuilder.SetActiveTab(this._$formTabs, "inquireTab", this._root);
      }
    }
  }, {
    key: "ShowInquiryBlankForm",
    value: function ShowInquiryBlankForm() {
      this._$inquiryBlankForm.style.display = "";

      this._$inquirefirstNameText.setAttribute("required", true);

      this._$inquirelastNameText.setAttribute("required", true);

      this._$inquireemailText.setAttribute("required", true);

      this._$inquirephoneText.setAttribute("required", true);
    }
  }, {
    key: "HideInquiryBlankForm",
    value: function HideInquiryBlankForm() {
      this._$inquiryBlankForm.style.display = "none";

      this._$inquirefirstNameText.removeAttribute("required");

      this._$inquirelastNameText.removeAttribute("required");

      this._$inquireemailText.removeAttribute("required");

      this._$inquirephoneText.removeAttribute("required");
    }
  }, {
    key: "ShowSignUpBlankForm",
    value: function ShowSignUpBlankForm() {
      this._$signupBlankForm.style.display = "";

      this._$signUpfirstNameText.setAttribute("required", true);

      this._$signUplastNameText.setAttribute("required", true);

      this._$signUpemailText.setAttribute("required", true);

      this._$signUpphoneText.setAttribute("required", true);
    }
  }, {
    key: "HideSignUpBlankForm",
    value: function HideSignUpBlankForm() {
      this._$signupBlankForm.style.display = "none";

      this._$signUpfirstNameText.removeAttribute("required");

      this._$signUplastNameText.removeAttribute("required");

      this._$signUpemailText.removeAttribute("required");

      this._$signUpphoneText.removeAttribute("required");
    }
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";
    }
  }, {
    key: "BuildInquiryForm",
    value: function BuildInquiryForm(i18n) {
      return  `<form id="inquiryForm" class="mppw-form mppw-form-validate"><input type="hidden" name="UseEmailTemplate" value="${this.inquiryEmailTemplate || ''}"/><div id="contactGroupDiv"><div id="inquireAsContainer" class="mppw-form-field mppw-form-field__static-container" style="display: none"><select name="ContactId" id="inquireAs" class="mppw-form-field__control" value=""></select> <label class="mppw-form-field__label" for="inquireAs">${i18n.inquireAsLabel}*:</label></div><div id="inquiryBlankForm"><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="FirstName" id="inquire_firstNameText" type="text" class="mppw-form-field__control" data-required-message="${i18n.firstNameRequired}" required/> <label class="mppw-form-field__label" for="inquire_firstNameText">${i18n.firstNameLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="LastName" type="text" id="inquire_lastNameText" class="mppw-form-field__control" data-required-message="${i18n.lastNameRequired}" required/> <label class="mppw-form-field__label" for="inquire_lastNameText">${i18n.lastNameLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="EmailAddress" id="inquire_emailText" type="email" class="mppw-form-field__control" data-required-message="${i18n.emailAddressRequired}" required data-require-if-blank="MobilePhoneNumber"/> <label class="mppw-form-field__label" for="inquire_emailText">${i18n.emailAddressLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="MobilePhoneNumber" type="tel" id="inquire_phoneText" class="mppw-form-field__control" data-required-message="${i18n.phoneNumberRequired}" required data-require-if-blank="EmailAddress"/> <label class="mppw-form-field__label" for="inquire_phoneText">${i18n.phoneNumberLabel}*:</label></div></div></div></div><div class="mppw-form-field"><textarea name="Message" id="inquire_messageText" class="mppw-form-field__control mppw-form-field__control__textarea" maxlength="500" value=""></textarea> <label class="mppw-form-field__label" for="inquire_messageText">${i18n.messageLabel}:</label><div class="mppw-textarea-counter"></div></div><div class="mppw-centered"><input id="contactGroupButton" type="submit" class="mppw-btn primary" value="${i18n.submitButtonText}"/></div></div></form>` ;
    }
  }, {
    key: "BuildSignUpForm",
    value: function BuildSignUpForm(i18n) {
      return  `<form id="signupForm" class="mppw-form mppw-form-validate"><input type="hidden" name="UseEmailTemplate" value="${this.signupEmailTemplate || ''}"/> <input type="hidden" name="LeaderSignupEmailTemplate" value="${this.leaderSignupEmailTemplate}"/><div class="mppw-form-field mppw-form-field__static-container"><select name="ContactId" id="signUpAs" class="mppw-form-field__control" value=""></select> <label class="mppw-form-field__label" for="signUpAs">${i18n.signUpAsLabel}*:</label></div><div id="signupBlankForm" style="display: none;"><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="FirstName" type="text" id="signUp_firstNameText" class="mppw-form-field__control" data-required-message="${i18n.firstNameRequired}" required/> <label class="mppw-form-field__label" for="">${i18n.firstNameLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="LastName" type="text" id="signUp_lastNameText" class="mppw-form-field__control" data-required-message="${i18n.lastNameRequired}" required/> <label class="mppw-form-field__label" for="">${i18n.lastNameLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="EmailAddress" type="email" id="signUp_emailText" class="mppw-form-field__control" required data-required-message="${i18n.emailAddressRequired}" data-require-if-blank="MobilePhoneNumber"/> <label class="mppw-form-field__label" for="">${i18n.emailAddressLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="MobilePhoneNumber" type="tel" id="signUp_phoneText" class="mppw-form-field__control" required data-required-message="${i18n.phoneNumberRequired}" data-require-if-blank="EmailAddress"/> <label class="mppw-form-field__label" for="signUp_phoneText">${ i18n.phoneNumberLabel}*:</label></div></div></div></div><div class="mppw-form-field"><textarea name="Message" id="signUp_messageText" class="mppw-form-field__control mppw-form-field__control__textarea" value="" maxlength="500"></textarea> <label class="mppw-form-field__label" for="">${i18n.messageLabel}:</label><div class="mppw-textarea-counter"></div></div><div class="mppw-centered"><input type="submit" class="mppw-btn primary" id="signUpButton" value="${i18n.signUpButtonText}"/></div></form>` ;
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Group Details",
        tag: "mpp-group-details",
        configurationItems: [{
          name: "Return URL",
          attribute: "returnurl",
          description: "URL that should point back the main Groups Widget.",
          required: true,
          type: "url"
        }, {
          name: "Inquire about Full Groups",
          attribute: "inquirefullgroups",
          description: "Allows Inquiries to be submitted for Groups which are full (Default: false).",
          required: false,
          type: "bool"
        }, {
          name: "Count Group Inquiries",
          attribute: "countgroupinquiries",
          description: "Allow Group Inquiries to count towards total Group Size (Default: false).",
          required: false,
          type: "bool"
        }, {
          name: "Inquiry Email Template",
          attribute: "inquiryemailtemplate",
          description: "Message ID in MinistryPlatform that will be used to send responses to individuals using Group Inquiry (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }, {
          name: "Sign Up Email Template",
          attribute: "signupemailtemplate",
          description: "Template ID in MinistryPlatform that will be used to send responses to individuals using Group Sign Up (Default: Empty or  NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }, {
          name: "Leader Contact Email Template",
          attribute: "leadersignupemailtemplate",
          description: "Template ID in MinistryPlatform that will be used to send messages to Group Leaders (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }, {
          name: "Show Full Group Address",
          attribute: "showfulladdress",
          description: "When True, the full group address will be shown (Default: false).",
          required: false,
          type: "bool"
        }, {
          name: "Hide Contact Tab",
          attribute: "hidecontacttab",
          description: "When True, hides the 'Contact this Group' tab and form (Default: false).",
          required: false,
          type: "bool"
        }, {
          name: "Hide Sign Up Tab",
          attribute: "hidesignuptab",
          description: "When True, hides the 'Sign Up for this Group' tab and form (Default: false).",
          required: false,
          type: "bool"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["countgroupinquiries", "inquirefullgroups", "inquiryemailtemplate", "returnurl", "showfulladdress", "signupemailtemplate", "hidecontacttab", "hidesignuptab", "leadersignupemailtemplate"];
    }
  }]);

  return MppGroupDetails;
}(ComponentBase);
MppGroupDetails.registerComponent(MppGroupDetails.WidgetDetails.tag, MppGroupDetails);